import './style/index.js';

import _InputAdornment from './InputAdornment';

export type { InputAdornmentProps } from './InputAdornment';
export * from './type';

export const InputAdornment = _InputAdornment;

export default _InputAdornment;
